import React, { createContext } from 'react';

const LanguageContext = createContext('FR');

export default LanguageContext;